import { Modal } from "@fluentui/react";
import React, { useContext, useEffect } from "react";
import ModalHeader from "../../../../../../components/Modal/ModalHeader";
import ModalFooter from "../../../../../../components/Modal/ModalFooter";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { KeyImageSchema } from "../../../../../../Schemas/KeyImageSchema";
import ATextField from "../../../../../../components/ATextField";
import studyviewerContext from "../../../../../../context/studyviewer/StudyviewerContext";
import {
  addKeyImages,
  isKeyImageTitleAlreadyPresent,
} from "../../../../helpers/KeyImageUtility";
import ViewportContext from "../../../../../../context/studyviewer/ViewportContext";
import { logAmplitudeEventWithUsernameAndRole } from "../../../../../../helpers/Amplitude";
import userContext from "../../../../../../context/users/UserContext";
import ModalMain from "../../../../../../components/Modal/ModalMain";
import studyReportContext from "../../../../../../context/studyreport/StudyReportContext";
import themeContext from "../../../../../../context/theme/ThemeContext";

const KeyImageInputModal = (props) => {
  const imageTitle = "";
  const { t } = useTranslation();
  const { patientResponseData, keyImages, setKeyImages } =
    useContext(studyviewerContext);
  const { username } = useContext(userContext);
  const { activeViewportIndex } = useContext(ViewportContext);
  const { setAlertSuccessModal, alertSuccessModal} = useContext(studyReportContext);
  const { getAlterColor } = useContext(themeContext);
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: { imageTitle },
      validationSchema: KeyImageSchema,
      onSubmit: async (values, action) => {
        console.log("is key submitted");
        if (isKeyImageTitleAlreadyPresent(keyImages, values.imageTitle)) {
          props.setShowInputKeyImageModal(false);
          //props.setShowDialogBox(true);
          //props.setDialogMessage(t("key-image.title-already-exists"));
          setAlertSuccessModal(()=>{
            const newItem = {...alertSuccessModal};
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = t("key-image.title-already-exists");
            return newItem;
          });
          action.resetForm();
          return;
        }
        addKeyImages(
          activeViewportIndex,
          keyImages,
          setKeyImages,
          values.imageTitle
        );
        logAmplitudeEventWithUsernameAndRole(
          "EVENT_BASIC_KEY_IMAGE_ADDED",
          {},
          username
        );
        props.setShowInputKeyImageModal(false);
        action.resetForm();
      },
    });

  useEffect(() => {
    console.log(keyImages);
  }, [keyImages]);

  const onKeyPress = (event) => {
    const keyCode = event.which;
    if (keyCode === 13) {
      handleSubmit();
    }
  };

  const modalDetails = {
    header: <ModalHeader updatedModal = {true} showPatientDetails={false} heading={t("key-image.key-image")} handleCancel={() => props.setShowInputKeyImageModal(false)}/>,
    footer : <ModalFooter
    DefaultButtonList={[
      {
        title: t("key-image.cancel"),
        onclick: () => props.setShowInputKeyImageModal(false),
      },
    ]}
    PrimaryButtonList={[
      {
        title: t("key-image.save"),
        onclick: handleSubmit,
      },
    ]}
  />,
    body :  <div onKeyDown={onKeyPress}>
    <div
      style={{
        height: "60px",
        display: "flex",
        alignItems: "flex-start",
        padding: "14px 20px",
        justifyContent: "flex-start",
      }}
    >
      <span
        style={{ color: getAlterColor("white",""), marginRight: "10px", paddingTop: "3px" }}
      >
        {t("key-image.image-title")}
      </span>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <ATextField
          name="imageTitle"
          onChange={handleChange}
          value={values.imageTitle}
          onBlur={handleBlur}
          // errorMessage={touched.imageTitle && errors.imageTitle}
        />
        <span style={{ color: "red", fontSize: "12px" }}>
          {touched.imageTitle && errors.imageTitle}
        </span>
      </div>
    </div>
    
  </div>,
    width : "350px"
  }

  return (
    <>
      {/* <Modal
        isOpen={props.showInputKeyImageModal}
        titleAriaId="id"
        scrollableContentClassName={"stop-scroll-for-modal"}
      >
       
      </Modal> */}
      <ModalMain showModal={props.showInputKeyImageModal} modalDetails={modalDetails}/>
    </>
  );
};

export default KeyImageInputModal;
